import React from 'react';
import {SectionWrapper, Title} from "../../../Common/CSS/src";
import styled from "styled-components/macro";
import Np1 from '../../../assets/images/companyImg/np1.jpg'
import Np2 from '../../../assets/images/companyImg/np2.jpg'
import Np3 from '../../../assets/images/companyImg/np3.jpg'
import Np4 from '../../../assets/images/companyImg/np4.jpg'
import Delivery from "../Delivery/delivery";

const Company = () => {
  return (
    <SectionWrapper>
      <CompanyWrapper>
        <Title>О нас</Title>
        {/*<h2>Производство натяжных потолков.</h2>*/}
        {/*<p>Наша компания производит натяжные потолки на протяжении десяти лет, и является лидером среди потолочных фирм Москвы*/}
        {/*    и*/}
        {/*    Московской области, имеющих собственное производство.</p>*/}
        {/*<h4>Производство натяжного потолка включает несколько этапов:</h4>*/}
        {/*<p>Первый – это создание материала, этим занимается завод. У нас контракты с несколькими заводами, среди которых*/}
        {/*    мировые*/}
        {/*    лидеры - Pongs (Германия) и MSD (Китай). Их качество проверено временем, к тому же, мы готовы предоставить все*/}
        {/*    подтверждающие сертификаты.</p>*/}
        {/*<p>С завода в роликах доставляется материал, а изготовление потолка под непосредственные размеры помещения происходит*/}
        {/*    уже*/}
        {/*    на нашем производстве в Москве. Ролики бывают разной ширины, от 1 до 5 метров, благодаря чему можно изготовить*/}
        {/*    потолок*/}
        {/*    без шва практически для любого помещения.</p>*/}
        {/*<h4>Процесс создания натяжного потолка из ПВХ происходит следующим образом:</h4>*/}
        {/*<p>От ролика отматывается полотно, из которого вырезается форма, четко соответствующая размеру помещения;<br/>По краям*/}
        {/*    потолка клеится специальный пластиковый гарпун, благодаря нему изделие крепится в багет для потолка;<br/>Потолок,*/}
        {/*    изготовленный по такой технологии, можно снимать и ставить обратно до 20 раз без ущерба для полотна.</p>*/}
        {/*<ImgWrapper>*/}
        {/*    <ul>*/}
        {/*        <li><img src={Np1} alt="#"/></li>*/}
        {/*        <li><img src={Np2} alt="#"/></li>*/}
        {/*        <li><img src={Np3} alt="#"/></li>*/}
        {/*        <li><img src={Np4} alt="#"/></li>*/}
        {/*    </ul>*/}
        {/*</ImgWrapper>*/}
        {/*<h4>Изготовление полотна из ткани имеет другие отличительные особенности.</h4>*/}
        {/*<p>Для монтажа тканевого потолка используется несколько другая система (так называемая «клипса» или «прищепка»),*/}
        {/*    поэтому*/}
        {/*    тканевый потолок выкраивается под особенности помещения непосредственно на монтаже, а с производства натяжных*/}
        {/*    потолков*/}
        {/*    уходит квадратный отрез такого размера, чтобы в этот квадрат полностью вписывалось помещение.</p>*/}
        {/*<h4>Технология изготовления натяжных потолков в нашей компании постоянно совершенствуется:</h4>*/}
        {/*<p>Мы отслеживаем новинки на рынке, в частности, регулярно обновляем парк станков для кроя материала;</p>*/}
        {/*<p>Регулярно рассматриваем новинки пленки, выходящей на рынок, и тщательно следим за качеством материалов, из которого*/}
        {/*    изготавливаем ваш потолок;</p>*/}
        {/*<p>Благодаря большим объемам, мы имеем эксклюзивные условия поставки, и незамедлительно обмениваем бракованную пленку у*/}
        {/*    производителя, что позволит вам не сомневаться в том, что ваши потолки всегда будут отменного качества.</p>*/}
        {/*<p>Приглашаем вас посетить наше производство натяжных потолков в Москве, ознакомиться с новейшими технологиями, и*/}
        {/*    получить*/}
        {/*    уникальную возможность поучаствовать в изготовлении своего потолка вместе с нашими специалистами.</p>*/}
        <h2>Фабрика натяжных потолков Price and Quality это:</h2>
        <p>➕ Качественные комплектующие и высокий уровень сервиса!</p>
        <p>➕ Оперативный раскрой</p>
        <p>➕ Построение полотен любой сложности.</p>
        <p>➕ Спец раскрой под Евро краб и Парящий</p>
        <p>➕ Принимаем заказы круглосуточно</p>
        <p>➕ Вся продукция имеет соответствующие сертификаты. Мы работаем всю неделю, без перерывов и выходных.</p>
        <p>➕ Доставку осуществляем по Москве и Московской области</p>
        <p>➕ Для постоянных клиентов, а также для заказов стоимостью свыше 20,000р. – доставка бесплатная.</p>


      </CompanyWrapper>
    </SectionWrapper>
  );
};

export default Company;

const CompanyWrapper = styled.div`
  p {
    color: #777;
    line-height: 26px;
    margin: 0 0 20px;
  }

  h2 {
    font-size: 2.2em;
    font-weight: 300;
    line-height: 42px;
    margin: 0 0 32px 0;
    text-align: center;
  }

  h4 {
    font-size: 1.4em;
    font-weight: 600;
    line-height: 27px;
    margin: 0 0 22px 0;
  }
`

const ImgWrapper = styled.div`
  margin: 20px 0;

  ul {
    display: flex;
    justify-content: space-between;

    li {
      width: 250px;

      img {
        width: 100%;
      }
    }

    @media (max-width: 550px) {
      flex-direction: column;
      li {
        width: 100%;
        margin-bottom: 10px;
      }
    }

  }
`